import { useEffect } from 'react';

/**
 * Custom hook to set the document title dynamically.
 * Appends " | Flowy" to all titles for consistent branding.
 *
 * @param {string} title - The page-specific title
 * @param {string[]} [deps=[]] - Optional dependencies to trigger title update
 */
const usePageTitle = (title, deps = []) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | Flowy` : 'Flowy';

    // Restore previous title on unmount (optional, for SPA navigation)
    return () => {
      document.title = previousTitle;
    };
  }, [title, ...deps]);
};

export default usePageTitle;
